/**
 * Badge: chip uppercase de 9px para estados/etiquetas compactas.
 *
 * Sprint 11 v2 S11-V2-02. Replica `.cb-badge` + variantes del handoff
 * (`docs/COMPONENTES.md § Badge y pill`).
 */
import type { ReactNode } from 'react';

type BadgeVariant = 'pending' | 'success' | 'warning' | 'danger' | 'info';

interface BadgeProps {
  variant: BadgeVariant;
  children: ReactNode;
  className?: string;
}

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  pending: 'bg-orange/20 text-orange',
  success: 'bg-state-success/15 text-state-success',
  warning: 'bg-state-warning/15 text-state-warning',
  danger: 'bg-state-danger/15 text-state-danger',
  info: 'bg-state-info/15 text-state-info',
};

export function Badge({ variant, children, className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center text-[9px] font-medium px-2 py-[2px] rounded-xs uppercase tracking-wide ${VARIANT_CLASSES[variant]} ${className}`.trim()}
    >
      {children}
    </span>
  );
}
